"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainId = void 0;
exports.chainId = '000000000019d6689c085ae165831e934ff763ae46a2a6c172b3f1b60a8ce26f';
